import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { PawPrint } from "@phosphor-icons/react";
import { useCart } from "@/context/CartContext";

export default function EmpireTotal() {
  const { count, total } = useCart();
  const navigate = useNavigate();

  // Don't clutter the page / cover content when the bag is empty.
  if (count === 0) return null;

  return (
    <button onClick={() => navigate("/cart")}
      className="fixed bottom-6 left-6 z-40 flex items-center gap-3 pl-3 pr-5 py-2.5 rounded-full bg-popover/90 backdrop-blur border border-primary/40 neon-glow hover:scale-105 transition-transform"
      data-testid="empire-total" aria-label="View bag">
      <AnimatePresence>
        {count > 0 && (
          <motion.span key={`pulse-${count}`} initial={{ opacity: 0.7, scale: 1 }} animate={{ opacity: 0, scale: 1.7 }} transition={{ duration: 0.7 }}
            className="absolute inset-0 rounded-full border-2 border-primary pointer-events-none" data-testid="empire-pulse" />
        )}
      </AnimatePresence>
      <span className="relative grid place-items-center h-9 w-9 rounded-full bg-primary text-primary-foreground">
        <PawPrint weight="fill" size={18} />
        {count > 0 && <span className="absolute -top-1 -right-1 h-4 min-w-4 px-1 rounded-full bg-accent text-[10px] grid place-items-center text-accent-foreground font-semibold">{count}</span>}
      </span>
      <span className="text-left leading-none">
        <span className="overline text-muted-foreground block mb-1">Empire Total</span>
        <AnimatePresence mode="popLayout">
          <motion.span key={total} initial={{ y: -8, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 8, opacity: 0 }}
            className="text-base font-modern text-primary block" data-testid="empire-amount">${total.toLocaleString()}</motion.span>
        </AnimatePresence>
      </span>
    </button>
  );
}
